import {ReactNode, useContext} from 'react';

import styled from 'styled-components';

import {media} from '~/shared/theme/media';
import {SnackbarContext} from '~/personalArea/components/Sections/Settings/Snackbar/SnackbarProvider';

const Root = styled.div<{opacity: number; transitionDuration: number}>`
  display: flex;
  padding: 12px 16px;
  bottom: 18px;
  left: 16px;
  right: 16px;
  position: fixed;
  opacity: ${({opacity}) => opacity};
  transition: opacity ${({transitionDuration}) => transitionDuration}ms ease-in-out;
  background-color: ${({theme}) => theme.colors.actionBlack};
  color: ${({theme}) => theme.colors.surface};
  border-radius: 8px;
  z-index: ${({theme}) => theme.zIndex.bottomSheet};
  ${media.minLargeMobile`
    bottom: auto;
    right: auto;
    top: ${({theme}) => theme.newHeader.height.rest + 18}px;
    left: 50%;
    transform: translate(-50%, 0);
  `}
`;

const SnackbarView = ({children}: {children: ReactNode}) => {
  const {isShown, opacity, transitionDuration} = useContext(SnackbarContext);

  if (!isShown) {
    return null;
  }

  return <Root opacity={opacity} transitionDuration={transitionDuration}>{children}</Root>;
};

export default SnackbarView;
